(() => {
  'use strict';
  const dialog = document.getElementById('qz-concierge');
  const engine = window.QuartzedConcierge;
  if (!dialog || !engine) return;
  const decode = value => {
    if (Array.isArray(value)) return value.map(decode);
    if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key,item])=>[key,decode(item)]));
    if (typeof value !== 'string') return value;
    const node=document.createElement('textarea');node.innerHTML=value;return node.value;
  };
  const copy = decode(JSON.parse(JSON.parse(document.getElementById('qz-concierge-copy').textContent)));
  const content = dialog.querySelector('[data-qz-concierge-content]');
  const status = dialog.querySelector('[data-qz-status]');
  const root = (dialog.dataset.root || '/').replace(/\/?$/, '/');
  const currency = dialog.dataset.currency;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency,currencyDisplay:'code'}).format(value/100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const text = (key, vars={}) => Object.entries(vars).reduce((s,[k,v]) => s.replaceAll('{'+k+'}',v),copy[key]);
  let session = 0, step = -1, answers = {}, products = [], cartIds = [], cataloguePromise = null, result = null, busy = false, openingElement = null, lastAdded = new Set();
  const primary = (label, attrs='') => `<button class="qz-concierge__primary" type="button" ${attrs}>${esc(label)}</button>`;
  const secondary = (label, attrs='') => `<button class="qz-concierge__secondary" type="button" ${attrs}>${esc(label)}</button>`;
  const eyebrow = label => `<p class="qz-concierge__eyebrow">${esc(label)}</p>`;
  function focusTitle() {
    content.querySelector('#qz-concierge-title')?.focus({preventScroll:true});
    dialog.scrollTop = 0;
  }
  async function request(url, options={}) {
    const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
    if (!response.ok) throw new Error('Request failed');
    return response;
  }
  function beginCatalog(force=false) {
    if (force) cataloguePromise = null;
    if (cataloguePromise) return cataloguePromise;
    cataloguePromise = (async () => {
      const nextProducts = [];
      let url = new URL(dialog.dataset.catalog, location.origin), page = 0;
      url.searchParams.set('view','qz-concierge-catalog');
      url.searchParams.set('sort_by','created-descending');
      while (url) {
        if (++page > 100) throw new Error('Catalogue pagination limit');
        const response = await request(url.toString());
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const node = doc.querySelector('[data-qz-concierge-catalog]');
        if (!node) throw new Error('Catalogue unavailable');
        const data = JSON.parse(node.textContent);
        if (data.currency !== currency) throw new Error('Currency changed');
        nextProducts.push(...data.products);
        url = data.next ? new URL(data.next,location.origin) : null;
        if (url) url.searchParams.set('view','qz-concierge-catalog');
      }
      products = [...new Map(nextProducts.map(p=>[String(p.id),p])).values()];
      return products;
    })();
    cataloguePromise.catch(()=>{});
    return cataloguePromise;
  }
  async function currentCart() {
    const cart = await (await request(root+'cart.js')).json();
    if (cart.currency !== currency) throw new Error('Currency changed');
    cartIds = cart.items.map(item=>String(item.variant_id));
    return cart;
  }
  function showIntro() {
    content.innerHTML = `<div class="qz-concierge__intro">${eyebrow(copy.eyebrow)}<h1 id="qz-concierge-title" tabindex="-1">${esc(copy.title)}</h1><p>${esc(copy.intro)}</p>${primary(copy.start,'data-qz-start')}</div>`;
    focusTitle();
  }
  function budgetLabel(option) {
    if (option.text) return option.text;
    if (option.min===0) return text('budgetUnder',{max:money(option.max)});
    if (option.max==null) return text('budgetOver',{min:money(option.min)});
    return text('budgetRange',{min:money(option.min),max:money(option.max)});
  }
  function showQuestion() {
    const q = copy.questions[step];
    status.textContent = '';
    content.innerHTML = `<p class="qz-concierge__step">${esc(text('step',{step:step+1}))}</p><div class="qz-concierge__progress" role="progressbar" aria-label="${esc(copy.title)}" aria-valuemin="0" aria-valuemax="4" aria-valuenow="${step+1}"><span style="width:${(step+1)*25}%"></span></div><fieldset><legend id="qz-concierge-title" tabindex="-1">${esc(q.title)}</legend>${q.hint?`<p>${esc(q.hint)}</p>`:''}<div class="qz-concierge__options">${q.options.map(o=>`<label class="qz-concierge__option"><input type="radio" name="qz-${q.key}" value="${esc(o.id)}" ${answers[q.key]===o.id?'checked':''}><span>${esc(q.key==='budget'?budgetLabel(o):o.text)}</span></label>`).join('')}</div></fieldset><div class="qz-concierge__actions">${secondary(copy.back,'data-qz-back')}${primary(step===3?copy.resultsButton:copy.next,'data-qz-next '+(answers[q.key]?'':'disabled'))}</div>`;
    focusTitle();
  }
  function productImage(p) {
    return p.image ? `<img class="qz-concierge__image" src="${esc(p.image)}" alt="${esc(p.title+(p.variant?' — '+p.variant:''))}" width="600" height="600" loading="lazy">` : '';
  }
  function productInfo(p) {
    return `<h3>${esc(p.title)}</h3>${p.variant?`<p class="qz-concierge__variant">${esc(p.variant)}</p>`:''}<p class="qz-concierge__price">${esc(p.formatted || money(p.price))}</p>`;
  }
  function why(p) {
    const need = copy.needs[answers.need];
    const format = copy[(p.format===answers.format?answers.format:'any')+'Reason'] || copy.anyReason;
    return (p.explanation || text('generalReason',{need:need.label.toLowerCase()}))+' '+format;
  }
  function buyButton(p) {
    if(p.inCart)return `<a class="qz-concierge__secondary" href="${esc(root+'cart')}">${esc(copy.cart)}</a>`;
    if (p.requiresSize) return `<a class="qz-concierge__secondary" href="${esc(p.url)}">${esc(copy.chooseSize)}</a>`;
    return primary(lastAdded.has(p.id)?copy.alreadyAdded:copy.add,`data-qz-add="${esc(p.id)}" ${lastAdded.has(p.id)?'disabled':''}`);
  }
  function budgetSwitcher() {
    const options=copy.questions.find(q=>q.key==='budget').options;
    return `<section class="qz-concierge__budgets" aria-labelledby="qz-budget-heading"><h3 id="qz-budget-heading">${esc(copy.exploreBudget)}</h3><p class="qz-concierge__budget-hint">${esc(copy.exploreBudgetHint)}</p><div class="qz-concierge__budget-options" role="group" aria-labelledby="qz-budget-heading">${options.map(o=>`<button type="button" class="qz-concierge__budget-button" data-qz-budget="${esc(o.id)}" aria-pressed="${answers.budget===o.id}">${esc(budgetLabel(o))}</button>`).join('')}</div></section>`;
  }
  function renderResults() {
    result = engine.recommend(products,answers,copy,cartIds);
    const need = copy.needs[answers.need];
    const reflection = copy.questions[0].options.find(o=>o.id===answers.struggle).reflection;
    const heading = answers.struggle==='giving' && answers.need==='love' ? copy.softHeartHeading : need.heading;
    const browseUrl = root+'collections/'+encodeURIComponent(need.collection);
    let html = `<div class="qz-concierge__results-header"><h2 id="qz-concierge-title" tabindex="-1">${esc(heading)}</h2><p>${esc(reflection)}</p></div>`;
    if (!result.picks.length) {
      content.innerHTML=html+`<a href="${esc(browseUrl)}" class="qz-concierge__primary">${esc(copy.cataloguecta)}</a><div class="qz-concierge__actions">${secondary(copy.restart,'data-qz-restart')}</div>${budgetSwitcher()}`;
      focusTitle();return;
    }
    const lead=result.picks[0], fit=lead.fit, closest=!fit.budget||!fit.format||!fit.intention;
    const actualNeeds=Object.entries(lead.weights).sort((a,b)=>b[1]-a[1]).slice(0,2).map(([id])=>copy.needs[id]?.label).filter(Boolean).join(' · ');
    const notes=[];
    if(closest) {
      const b=engine.budgetFor(answers,copy);
      if(fit.budget)notes.push(copy.closestinrange);
      else notes.push(lead.price<b.min?copy.closestbelow:text('closestabove',{range:budgetLabel(b),price:money(lead.price)}));
      if(!fit.format)notes.push(text('closestformat',{actual:copy['fallback'+(lead.format||'unknown')],requested:copy['fallback'+answers.format]}));
      if(!fit.intention)notes.push(text('closestintention',{actual:actualNeeds.toLowerCase(),requested:need.label.toLowerCase()}));
    }
    if(lead.inCart)notes.push(copy.fallbackcart);
    html += `<article class="qz-concierge__lead qz-concierge__card"><a href="${esc(lead.url)}">${productImage(lead)}</a><div>${eyebrow(closest?copy.closestlabel:copy.primary)}${productInfo(lead)}${notes.length?`<p class="qz-concierge__small" data-qz-closest>${esc(notes.join(' '))}</p>`:''}<p class="qz-concierge__energy">${esc(fit.intention?need.energy:actualNeeds)}</p><p>${esc(lead.explanation || (fit.intention?text('generalReason',{need:need.label.toLowerCase()}):copy.fallbackgeneral))}</p>${buyButton(lead)} <a class="qz-concierge__text-link" href="${esc(lead.url)}">${esc(copy.view)} →</a></div></article>`;
    html += `<div class="qz-concierge__ritual">${eyebrow(copy.ritualLabel)}<p>${esc(need.ritual)}</p></div>`;
    if (result.pair) {
      const pair=result.pair, companion=pair.items[1];
      html += `<section class="qz-concierge__pair"><div class="qz-concierge__pair-item"><a href="${esc(companion.url)}">${productImage(companion)}</a><div>${eyebrow(copy.pairEyebrow)}<a href="${esc(companion.url)}">${esc(companion.title)}</a>${companion.variant?`<p>${esc(companion.variant)}</p>`:''}<p>${esc(companion.formatted||money(companion.price))}</p></div></div><p class="qz-concierge__pair-why">${esc(pair.rule.why)}</p>${primary(copy.pairAdd+' · '+money(pair.total),'data-qz-pair')}</section>`;
    }
    html += `<details class="qz-concierge__details qz-concierge__affirmation"><summary>${esc(copy.alternatives)}</summary><p>${esc(copy.affirmations[answers.need])}</p></details><div class="qz-concierge__actions">${secondary(copy.edit,'data-qz-edit')}${secondary(copy.restart,'data-qz-restart')}<a href="${esc(root+'cart')}" class="qz-concierge__text-link">${esc(copy.cart)} →</a></div>`;
    content.innerHTML=html+budgetSwitcher();focusTitle();
  }
  async function showResults(force=false) {
    const activeSession=session;
    step=4;
    content.innerHTML=`<div class="qz-concierge__loading"><h2 id="qz-concierge-title" tabindex="-1">${esc(copy.loading)}</h2></div>`;
    focusTitle();
    try {
      await Promise.all([beginCatalog(force),currentCart()]);
      if (step!==4 || session!==activeSession || !dialog.open) return;
      renderResults();
    } catch(error) {
      if (step!==4 || session!==activeSession || !dialog.open) return;
      content.innerHTML=`<h2 id="qz-concierge-title" tabindex="-1">${esc(copy.loadError)}</h2><div class="qz-concierge__actions">${secondary(copy.retry,'data-qz-retry')}${secondary(copy.edit,'data-qz-edit')}</div>`;
      focusTitle();
    }
  }
  async function updateThemeCart(cart) {
    document.querySelectorAll('.js-cart-count').forEach(el=>{el.textContent=cart.item_count;el.classList.toggle('cart-empty',cart.item_count===0);});
    try {
      const response=await request(root+'cart/?view=ajax');
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const fragment=parsed.querySelector('template[data-html="content"]');
      if (fragment) document.querySelectorAll('.js-ajax-cart-content').forEach(el=>{el.innerHTML=fragment.innerHTML;});
      const config=JSON.parse(document.getElementById('cart-config')?.textContent||'{}');
      window.Shopify?.theme?.ajaxCart?.cartEvents(config);
    } catch(error) {
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart}}));
    }
  }
  async function addItems(items, button) {
    if (busy || button.disabled) return;
    busy=true;
    const activeSession=session;
    const original=button.textContent;
    dialog.querySelectorAll('[data-qz-add],[data-qz-pair]').forEach(b=>{b.disabled=true;});
    button.textContent=copy.adding;
    status.textContent='';
    try {
      const cart=await currentCart();
      if (items.some(p=>cartIds.includes(p.id))) {
        if (session===activeSession && dialog.open) {await showResults(true);status.textContent=copy.cartChanged;}return;
      }
      const fresh=await Promise.all(items.map(async p=>{
        const data=await(await request(root+'products/'+encodeURIComponent(p.handle)+'.js')).json();
        return data.variants.find(v=>String(v.id)===p.id);
      }));
      if (fresh.some((v,i)=>!v?.available || Number(v.price)!==items[i].price)) {
        if (session===activeSession && dialog.open) {await showResults(true);status.textContent=copy.changed;}return;
      }
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items.map(p=>({id:Number(p.id),quantity:1}))})});
      const added=await response.json();
      if (!response.ok || added.status>=400) throw new Error('Cart addition failed');
      items.forEach(p=>lastAdded.add(p.id));
      const updated=await currentCart();
      await updateThemeCart(updated);
      if (session!==activeSession || !dialog.open) return;
      renderResults();
      status.innerHTML=`${esc(copy.added)} <a href="${esc(root+'cart')}">${esc(copy.cart)} →</a>`;
    } catch(error) {
      if (session!==activeSession || !dialog.open) return;
      status.innerHTML=`${esc(error.message==='Currency changed'?copy.currencyChanged:copy.cartError)} <a href="${esc(root+'cart')}">${esc(copy.cart)} →</a>`;
      cataloguePromise=null;
    } finally {
      busy=false;
      if (button.isConnected) button.textContent=original;
      dialog.querySelectorAll('[data-qz-add],[data-qz-pair]').forEach(b=>{b.disabled=Boolean(b.dataset.qzAdd&&lastAdded.has(b.dataset.qzAdd));});
    }
  }
  function open(trigger) {
    openingElement=trigger||document.activeElement;
    document.querySelector('.mobile-menu .js-slideout-close')?.click();
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('qz-concierge-open');
    status.textContent='';
    session++;step=-1;answers={};result=null;
    beginCatalog(true);showIntro();
  }
  dialog.addEventListener('close',()=>{
    session++;step=-1;answers={};result=null;status.textContent='';
    document.documentElement.classList.remove('qz-concierge-open');
    const returnTo=openingElement?.closest('.mobile-menu')?document.querySelector('[aria-label="Open navigation"]'):openingElement;
    if (returnTo?.isConnected) returnTo.focus({preventScroll:true});
  });
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-qz-concierge-open]');
    if (!trigger) return;
    event.preventDefault();open(trigger);
  });
  dialog.addEventListener('change',event=>{
    if (event.target.matches('input[type="radio"]')) {
      answers[copy.questions[step].key]=event.target.value;
      content.querySelector('[data-qz-next]').disabled=false;
    }
  });
  dialog.addEventListener('click',event=>{
    const button=event.target.closest('button,a');
    if (!button) return;
    if (busy && !button.matches('[data-qz-close]')) {event.preventDefault();return;}
    if (button.matches('[data-qz-close]')) dialog.close();
    else if (button.matches('[data-qz-start]')) {step=0;showQuestion();}
    else if (button.matches('[data-qz-back]')) {step--;step<0?showIntro():showQuestion();}
    else if (button.matches('[data-qz-next]')) {if (answers[copy.questions[step].key]) {step++;step===4?showResults():showQuestion();}}
    else if (button.matches('[data-qz-budget]')) {
      const id=button.dataset.qzBudget;
      if(step!==4 || !copy.questions.find(q=>q.key==='budget').options.some(o=>o.id===id) || answers.budget===id)return;
      answers.budget=id;status.textContent='';renderResults();
      content.querySelector('[data-qz-budget="'+id+'"]')?.focus({preventScroll:true});
      content.querySelector('#qz-concierge-title')?.scrollIntoView?.({block:'start',behavior:'instant'});
    }
    else if (button.matches('[data-qz-retry]')) showResults(true);
    else if (button.matches('[data-qz-edit]')) {event.preventDefault();step=0;showQuestion();}
    else if (button.matches('[data-qz-restart]')) {answers={};step=0;showQuestion();}
    else if (button.matches('[data-qz-add]')) {const item=result?.picks.find(p=>p.id===button.dataset.qzAdd);if(item)addItems([item],button);}
    else if (button.matches('[data-qz-pair]')&&result?.pair) addItems(result.pair.items,button);
  });
  if(['#your-energy-is-calling','#your-crystal-match'].includes(location.hash)) open();
})();

